/**
 * Determines whether a password is valid based on the number of chars and digits.
 * Currently, first line is disabled since it demands a default export,
 * but there may be other validation functions in the future.
 * @param {string} password
 * @returns {boolean} true if password is long enough and has a digit
 */
export function passwordHasMinCharsAndDigits(password) { // eslint-disable-line
  if (password.length < 8 || !/\d/.test(password)) {
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/helper/validation.js